import { Helmet } from 'react-helmet-async';
// sections
import UserTelePackageResponses from 'src/sections/doctor-dashboard/telepackages/telepackages-list-view';

// ----------------------------------------------------------------------

export default function Page() {

  return (
    <>
      <Helmet>
        <title> User Responses List Page</title>
      </Helmet>

      <UserTelePackageResponses />
    </>
  );
}
